export function SuccessIcon() {
  return (
    <img
      src={require("../../../assets/images/success-icon.png")}
      alt="success"
    />
  );
}